import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

export default function IntrusionDetection() {
  return (
    <div className="min-h-screen bg-[#111111] text-white">
      <Helmet>
        <title>Ajax Intrusion Detection Systems | SeguraTech</title>
        <meta
          name="description"
          content="Ajax intrusion detection systems including starter kits and professional-grade sensors, installed and configured by SeguraTech."
        />
      </Helmet>

      {/* Intro */}
      <section className="max-w-6xl mx-auto px-4 py-20 text-center">
        <h1 className="text-4xl font-bold text-[#C6A564] mb-6">
          Intrusion Detection
        </h1>

        <p className="text-white/80 max-w-3xl mx-auto">
          Ajax intrusion detection systems provide fast, encrypted wireless
          protection using intelligent motion sensors, door contacts, and
          expandable alarm hubs.
        </p>
      </section>

      {/* Products */}
      <section className="max-w-6xl mx-auto px-4 pb-24">
        <h2 className="text-2xl text-[#C6A564] mb-8 font-light">
          Available Systems
        </h2>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">

          {/* Starter Kit */}
          <Link
            to="/alarms/ajax/starter-kit"
            className="block rounded-2xl border border-[#C6A564] bg-[#1A1A1A] p-6 hover:bg-[#222222] transition"
          >
            <h3 className="text-lg text-[#C6A564] mb-2 font-light">
              Ajax Baseline Kit
            </h3>

            <p className="text-white/70">
              A complete entry-level Ajax alarm system, ideal for homes and
              small premises.
            </p>
          </Link>

          {/* Future devices placeholder */}
          <div className="rounded-2xl border border-[#2E2E2E] bg-[#141414] p-6 opacity-60">
            <h3 className="text-lg mb-2 font-light">
              Individual Sensors
            </h3>

            <p className="text-white/60">
              Motion detectors, door contacts, and glass break sensors.
              (Coming soon)
            </p>
          </div>

        </div>
      </section>
    </div>
  );
}
